import { useState } from "react";
import { RefreshCw, Diamond, LogOut, Users } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { AccessPanel } from "@/components/auth/AccessPanel";

export const Navbar = ({ onRefresh, loading, single = false }) => {
  const { user, logout } = useAuth();
  const [accessOpen, setAccessOpen] = useState(false);

  return (
  <header
    data-testid="main-navbar"
    className="fixed top-0 left-0 right-0 z-50 backdrop-blur-xl bg-white/70 border-b border-slate-200"
  >
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-10 h-16 flex items-center justify-between">
      <a href="#top" className="flex items-center gap-3" data-testid="nav-brand">
        <span className="w-8 h-8 rounded-full bg-slate-900 flex items-center justify-center">
          <Diamond size={15} className="text-[#D4AF37]" />
        </span>
        <span className="font-display text-lg font-semibold tracking-tight">
          OPM Group <span className="text-slate-400 italic font-normal">/ MIS</span>
        </span>
      </a>
      <nav className="hidden md:flex items-center gap-8 text-xs font-semibold uppercase tracking-[0.2em] text-slate-500">
        <a href="#overview" className="hover:text-slate-900 transition-colors" data-testid="nav-overview">Overview</a>
        <a href="#trends" className="hover:text-slate-900 transition-colors" data-testid="nav-trends">Trends</a>
        {!single && <a href="#compare" className="hover:text-slate-900 transition-colors" data-testid="nav-compare">Compare</a>}
        <a href="#ledger" className="hover:text-slate-900 transition-colors" data-testid="nav-ledger">Ledger</a>
      </nav>
      <div className="flex items-center gap-2">
        {user?.is_admin && (
          <button
            onClick={() => setAccessOpen(true)}
            data-testid="access-btn"
            className="flex items-center gap-1.5 rounded-full border border-slate-200 text-slate-600 text-xs font-semibold px-3.5 py-2 hover:border-slate-400 transition-colors"
          >
            <Users size={13} /> <span className="hidden sm:inline">Access</span>
          </button>
        )}
        <button
          onClick={() => onRefresh(true)}
          data-testid="refresh-data-btn"
          className="flex items-center gap-2 rounded-full bg-slate-900 text-white text-xs font-semibold px-4 py-2 hover:bg-slate-700 transition-colors"
        >
          <RefreshCw size={13} className={loading ? "animate-spin" : ""} />
          <span className="hidden sm:inline">Sync Sheet</span>
        </button>
        {user?.picture ? (
          <img src={user.picture} alt={user.name} referrerPolicy="no-referrer" className="w-8 h-8 rounded-full border border-slate-200" data-testid="user-avatar" />
        ) : user ? (
          <span className="w-8 h-8 rounded-full bg-[#D4AF37] text-white text-xs font-bold flex items-center justify-center" data-testid="user-avatar">
            {(user.name || user.email || "?").charAt(0).toUpperCase()}
          </span>
        ) : null}
        <button
          onClick={logout}
          data-testid="logout-btn"
          title="Sign out"
          className="text-slate-400 hover:text-red-500 transition-colors p-1.5"
        >
          <LogOut size={15} />
        </button>
      </div>
    </div>
    <AccessPanel open={accessOpen} onOpenChange={setAccessOpen} />
  </header>
  );
};
